const headerMenuConfig = [];
const asideMenuConfig = [
  {
    name: '首頁',
    path: '/ui',
    icon: 'chart-bar',
  },
  {
    name: '對應',
    path: '/ui/Portmap',
    icon: 'account',
  },
  {
    name: '帳號',
    path: '/ui/Login',
    icon: 'account',
  },
  {
    name: '關於',
    path: '/ui/about',
    icon: 'help',
  },
];
export { headerMenuConfig, asideMenuConfig };
